import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type {
  SubmitFeedbackRequestDto,
  SubmitFeedbackResponseDto,
  SubmitNewProspectRequestDto,
  SubmitNewProspectResponseDto,
} from '../../generated/models';

// Domain types
import type { SubmitFeedbackResponse, SubmitNewProspectResponse } from '@api/domain/types';

// Mappers
import { toSubmitFeedbackResponse, toSubmitNewProspectResponse } from '@api/domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  feedback: typedMethodPost<SubmitFeedbackRequestDto, SubmitFeedbackResponseDto, SubmitFeedbackResponse>(
    (data) =>
      fetch(`${baseURL}/v1/ticket/feedback`, {
        method: 'POST',
        ...data,
      }),
    toSubmitFeedbackResponse
  ),
  prospect: typedMethodPost<SubmitNewProspectRequestDto, SubmitNewProspectResponseDto, SubmitNewProspectResponse>(
    (data) =>
      fetch(`${baseURL}/v1/membershipOnboarding/submitNewProspect`, {
        method: 'POST',
        ...data,
      }),
    toSubmitNewProspectResponse
  ),
});

// Re-export domain types for consumers
export type { SubmitFeedbackResponse, SubmitNewProspectResponse };
